import React, { Component } from 'react'
import { getBusinessInfo } from '../firebase/obj/businessInfo'
import WhatsappButton from '../components/whatsappButton'

export default class WhatsappButtonWithData extends Component {
    constructor() {
        super()
        this._isMounted = false
        this.state = {
            businessInfo: null
        }
    }


    loadBusinessInfo() {
        const _this = this
        getBusinessInfo().then(businessInfo => {
            _this.setState({
                businessInfo
            })
        }).catch(_this.setState({ businessInfo: null }))
    }

    componentDidMount() {
        this._isMounted = true
        this._isMounted && this.loadBusinessInfo()
    }

    componentWillUnmount() {
        this._isMounted = false
        this.setState({ businessInfo: null })
    }


    render() {
        return (
            <React.Fragment>
                {
                    this.state.businessInfo ?
                        <WhatsappButton number={this.state.businessInfo.whatsapp} />
                        :
                        <React.Fragment />
                }
            </React.Fragment>
        )
    }
}